<template>
  <div class="salesmantuijianmingxi">      
      <mu-appbar title="我的推荐">
        <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>
      </mu-appbar>
      <!--
      <div class="total balance" :style="{  backgroundImage:'url('+siteConfig.MobileBgImage+')' }">
          <p class="title">总人数(人)</p>
          <p class="money">{{countInfo.tjtotal}}</p>
      </div>
      -->
      <div style="width:100vw;height:28vw;background:#f9436b;display:inline-block;line-height:100%;">
        <div style="display:flex;align-items:center;justify-items:center;justify-content:space-between;margin-top:5vw;width:100vw;height:9vw;">
          <div style="display:block;width:30vw;height:9vw;text-align:center;font-size:14px;color:#fff;">推荐人数</div>
          <div style="display:block;width:30vw;height:9vw;text-align:center;font-size:14px;color:#fff;">粉丝人数</div>
          <div style="display:block;width:28vw;height:9vw;text-align:center;font-size:14px;color:#fff;text-align:left;margin-left:3vw;">市场总业绩</div>
        </div>
        <div style="display:flex;align-items:center;justify-items:center;justify-content:space-between;margin-top:0;width:100vw;height:12vw;">
          <div style="display:block;width:30vw;height:12vw;text-align:center;font-size:22px;color:#fff;font-weight:bold;">{{countInfo.tjtotal}}</div>
          <div style="display:block;width:30vw;height:12vw;text-align:center;font-size:22px;color:#fff;font-weight:bold;">{{countInfo.total}}</div>
          <div style="display:block;width:28vw;height:12vw;text-align:center;font-size:20px;color:#fff;text-align:left;font-weight:bold;margin-left:3vw;">{{countInfo.totalAchievement}}</div>
        </div>
      </div>
      <mu-list>
        <router-link :to="'/salesman/mytuijianlist?userbs=0&pageTitle=' + (saleMenCategory?(saleMenCategory[0]?saleMenCategory[0]:'普通会员'):'普通会员')" class="proList">
          <mu-list-item :title="saleMenCategory?(saleMenCategory[0]?saleMenCategory[0]:'普通会员'):'普通会员'">
            <mu-icon slot="left" value=":fa fa-myhuiyuan  "/>
            <p>{{countInfo.tjpttotal}}</p>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link>
        
        <router-link :to="'/salesman/mytuijianlist?userbs=1&pageTitle=' + (saleMenCategory?saleMenCategory[1]:'创客')" class="proList">
          <mu-list-item :title="saleMenCategory?saleMenCategory[1]:'创客'" >
            <mu-icon slot="left" value=":fa fa-mydianzhu"/>
            <p>{{countInfo.tjzctotal}}</p>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link>
        
        <router-link :to="'/salesman/mytuijianlist?userbs=4&pageTitle=' + (saleMenCategory?saleMenCategory[4]:'社区服务商')" class="proList">
          <mu-list-item :title="saleMenCategory?saleMenCategory[4]:'社区服务商'" v-if="showOne">
            <mu-icon slot="left" value=":fa fa-myshequ"/>
            <p>{{countInfo.tjsqtotal}}</p>
            <mu-icon style="font-size:20px;"  slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link>
        
        <router-link :to="'/salesman/mytuijianlist?userbs=6&pageTitle=' + (saleMenCategory?saleMenCategory[6]:'县区管理中心')" class="proList">
          <mu-list-item :title="saleMenCategory?saleMenCategory[6]:'县区管理中心'" v-if="showTwo">
            <mu-icon style="font-size:20px;"  slot="left" value=":fa fa-myxianqu"/>
            <p>{{countInfo.tjxqtotal}}</p>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link>
        
        <router-link :to="'/salesman/mytuijianlist?userbs=7&pageTitle=' + (saleMenCategory?saleMenCategory[7]:'市级运营中心')" class="proList">
          <mu-list-item :title="saleMenCategory?saleMenCategory[7]:'市级运营中心'" v-if="showThree">
            <mu-icon style="font-size:20px;"  slot="left" value=":fa fa-myxianqu"/>
            <p>{{countInfo.tjsjtotal}}</p>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link>

        <router-link :to="'/salesman/mytuijianlist?userbs=8&pageTitle=' + (saleMenCategory?saleMenCategory[8]:'省级分公司')" class="proList">
          <mu-list-item :title="saleMenCategory?saleMenCategory[8]:'省级分公司'" v-if="countInfo.tjprovincetotal>0">
            <mu-icon style="font-size:20px;"  slot="left" value=":fa fa-myxianqu"/>
            <p>{{countInfo.tjprovincetotal}}</p>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link>
        
        <router-link :to="'/salesman/mytuijianlist?userbs=2&pageTitle=' + (saleMenCategory?saleMenCategory[2]:'县区管理商')" class="proList">
          <mu-list-item :title="saleMenCategory?saleMenCategory[2]:'县区管理商'" v-if="countInfo.tjglstotal>0">
            <mu-icon style="font-size:20px;"  slot="left" value=":fa fa-myxianqu"/>
            <p>{{countInfo.tjglstotal}}</p>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link>
      </mu-list>

      <!-- <XR-toast ref="XRtoast"></XR-toast> -->
  </div>
</template>
<script>
export default {
  data () {
    return {
     activeTab:'tab1',
     searchInfo:{
       pageIndex:1,
       pageSize:1000,
       zcpv: '',
       shbs: '',
       startdate:'',
       enddate:'',
       tjbs:'',
       
     },
     showOne:false,
     showTwo:false,
     showThree:false,
     countInfo:{
       tjpttotal:0,
       tjzctotal:0,
       tjsqtotal:0,
       tjxqtotal:0,
       tjtotal:0,
       tjprovincetotal:0
     },
     topPopup: false,
     memberList:{},
     siteConfig:{ MobileBgImage : '' },
	 saleMenCategory:window.localStorage.saleMenCategory.split(",")
    }
  },
  mounted(){
    this.getSiteInfo()
    this.getCount()
    this.getMemberList()
  },
    methods: {
     
    getSiteInfo: function () {    
        const ths = this;
        this.$post('/Shop/SiteConfigServer/GetSiteConfig')
            .then(function (res) {
            if(res.IsSuccess){
                ths.siteConfig = res.Data
            }         
        })
        .catch(function (err) {
            console.log(err)
        })    
    },      
    searchType (val) {
      if(val == -1){
        this.searchInfo.zcpv = ''
        this.searchInfo.shbs = ''
      }
      else if(val == 0){
        this.searchInfo.zcpv = 0
        this.searchInfo.shbs = 0
      }
      else if(val == 1){
        this.searchInfo.zcpv = 0
        this.searchInfo.shbs = 1
      }
      else if(val == 4){
        this.searchInfo.zcpv = 1
        this.searchInfo.shbs = 1
      }
      else if(val == 6){
        this.searchInfo.zcpv = 2
        this.searchInfo.shbs = 1
      }
      else if(val == 7){
        this.searchInfo.zcpv = 4
        this.searchInfo.shbs = 1
      }
      this.getMemberList()
      this.close('top')
    },
    
    getCount(){           
      const ths = this;

      this.$post("/Salesman/SalesmanServer/GetTuijianCount")
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false;          
          ths.countInfo = res.Data;
          if(ths.countInfo.tjsqtotal!=0){
            ths.showOne=true
          }
          if(ths.countInfo.tjxqtotal!=0){
            ths.showTwo=true
          }
          if(ths.countInfo.tjsjtotal!=0){
            ths.showThree=true
          }
          ths.$refs.XRtoast.hide();
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },    
    getMemberList(){           
      const ths = this;
      this.$post("/Salesman/SalesmanServer/GetTuijianRelationStream", this.searchInfo)
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false;
          
          ths.memberList = res.Data

          ths.$refs.XRtoast.hide();
        }else{
          ths.memberList = {}
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },    
    open (position) {
      this[position + 'Popup'] = true
      this.titleIcon = "fa fa-angle-up";
    },
    close (position) {
      this[position + 'Popup'] = false
      this.titleIcon = "fa fa-angle-down";
    },
    GoHistory(){
      this.$router.goBack()
    }
  }
}
</script>
<style>

      body .salesmantuijianmingxi{
        background: #fff;
      }
      .salesmantuijianmingxi .total {
          padding: 20px;
          overflow: hidden;
          background: url("/static/us-top-bg.png");
          background-size: 100% 100%;
      }
      .salesmantuijianmingxi .title {
          line-height: 24px;
          font-size: 14px;
          color: #fff;
      }
      .salesmantuijianmingxi .show-right .mu-item-content{
          display: flex;
      }
      .salesmantuijianmingxi .show-right .mu-item-title-row{
        width: 100%;
      }
      .salesmantuijianmingxi .text{
        color: #666666;
      }
      .salesmantuijianmingxi .proList .mu-item-wrapper{
        border-bottom: 1px solid #f5f5f5;
      }
      .salesmantuijianmingxi .money {
          font-size: 46px;
          color: red;
          line-height: 42px;
          padding: 10px 0;
          letter-spacing: -1px;
          color: #fff;
      }
      .salesmantuijianmingxi .mu-appbar .mu-appbar-title{
        font-size: 16px;
      }
      .salesmantuijianmingxi h5
        {
            font-size:16px;
            text-align:center;  
            font-weight:400;  
            padding:17px 0;
        }
      .salesmantuijianmingxi .mu-item.show-right{
        padding-left: 50px;
      }
      .salesmantuijianmingxi .mu-icon{
        margin-bottom: 5px;
      }
</style>



// WEBPACK FOOTER //
// src/pages/salesman/mytuijian.vue